import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

document.addEventListener('DOMContentLoaded', () => {
  const searchRoot = document.querySelector('.dynamic-search-root');

  if (searchRoot) {
    try {
      const config = JSON.parse(searchRoot.dataset.config);

      ReactDOM.createRoot(searchRoot).render(
        <React.StrictMode>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <App config={config} />
            </BrowserRouter>
          </QueryClientProvider>
        </React.StrictMode>
      );

      const observer = new MutationObserver(() => {
        observer.disconnect()
        Drupal.attachBehaviors(searchRoot)
      })
      observer.observe(searchRoot, {
        childList: true
      })
    } catch (error) {
      console.error('Error rendering React app:', error);
    }
  } else {
    console.log('No search root element found');
  }
});
